import { MondayApiQueryInstance } from "../../services/monday/monday-service-ts";
import { ItemsPageSlice } from "../../services/monday/monday-query-interface";

/**
 * First page of board items via `boards { items_page }`.
 * See: https://developer.monday.com/api-reference/reference/items-page
 */
export const fetchFirstItemsPage = async (
  boardId: number,
  limit: number,
  searchTerm?: string,
): Promise<ItemsPageSlice> => MondayApiQueryInstance.getItemsPage(boardId, limit, searchTerm);

/**
 * Next page via root `next_items_page` (cursor from the previous page).
 * See: https://developer.monday.com/api-reference/reference/next-items-page
 */
export const fetchNextItemsPage = async (cursor: string, limit: number): Promise<ItemsPageSlice> =>
  MondayApiQueryInstance.getNextItemsPage(cursor, limit);
